import { Spin, SpinProps } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { FC } from 'react';
import styles from './styles.module.less';

type SpinnerProps = Omit<SpinProps, 'indicator' | 'className'>;

const Spinner: FC<SpinnerProps> = (props) => {
  return <Spin {...props} indicator={<LoadingOutlined />} className={styles['absolute-align-center']} data-testid="spinner" />;
};

export default Spinner;
